<ng-container *ngIf="isSandboxCard; else showServiceCard">
  <app-sandbox-card [loader]="loader" [sandbox]="sandbox" [sandboxCardInfo]="sandboxCardInfo" class="mb-24 display-card"></app-sandbox-card>
</ng-container>
<ng-template #showServiceCard>
  <app-service-card [loader]="loader" [isSandboxCard]="isSandboxCard" [serviceCardInfo]="serviceCardInfo" [tenantDetails]="tenantDetails" [serviceVersions]="serviceVersions" (blueprintDeleted)="onBlueprintDeleted($event)" *ngIf="serviceCardInfo && !serviceDeleted && !permissionsMap[Permission.NO_SERVICES]" class="mb-24 display-card"></app-service-card>
</ng-template>
